import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const SagaProcessRoutes: Routes = [
  {
    path: "saga-process",
    loadComponent: () =>
      import("./saga-process/saga-process.component").then(
        (m) => m.SagaProcessComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./saga-process-list/saga-process-list.component").then(
            (m) => m.SagaProcessListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./saga-process-form/saga-process-form.component").then(
            (m) => m.SagaProcessFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./saga-process-form/saga-process-form.component").then(
            (m) => m.SagaProcessFormComponent,
          ),
      },
    ],
  },
];
